<template>
  <div class="p-4">
    <b-row>
      <b-col cols="12">
        <b-button variant="ghost" class="go-back-btn shadow-none px-0 mb-3 d-flex align-items-center" @click="handleGoBack">
          <img src="../../assets/images/arrow-back.svg" alt="Go Back" class="mr-2">
          Go Back
        </b-button>
      </b-col>
      <b-col cols="12">
        <h2>{{ displayName }}</h2>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col lg="2" md="4">
        <b-form-group>&nbsp;</b-form-group>
      </b-col>
      <b-col lg="10" md="8">
        <b-navbar id="schedule-tabs" variant="faded" type="light" class="px-0">
          <b-navbar-nav>
            <b-nav-item
              :active="schedule_type == 'days_only'"
              @click="schedule_type = 'days_only'" link-class="px-0">
              Ask for Days
            </b-nav-item>
            <b-nav-item
              :active="schedule_type == 'days_and_time'"
              @click="schedule_type = 'days_and_time'">
              Ask for Days & Time
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col lg="2" md="4">
        <b-form-group label="Operational Days" label-class="fulfillment-form-label">
          <router-link
            :to="{ name: 'StoreOrganization', params: { branch_uuid: routerLinkProperties.branch_uuid } }"
            :class="{ 'disabled-edit-store-hours': !isStoreModule() }">
          <b-button
            variant="outline-primary"
            :class="['go-to-edit-store', { 'outline-disabled': !isStoreModule() }]">
            <img src="../../assets/images/edit-primary-alt.svg" alt="Go to Edit Store">
            Edit
          </b-button>
          </router-link>
        </b-form-group>
      </b-col>
       <b-col lg="10" md="8">
        <div class="bg-white rounded p-4 form-container">
          <span class="store-edit-note bg-light mb-3 rounded px-3 py-2">
            <img src="../../assets/images/el_info-circle.svg" alt="Store Edit Info" class="mr-2">
            <small>This setting is editable in Brand/Branch Module</small>
          </span>
          <b-row
            no-gutters
            v-for="(operation, opIndex) in storeHours" :key="`operation_${opIndex}`"
            :class="['operation-item p-2 d-flex align-items-center justify-content-between border rounded',
            { 'mb-3': opIndex !== storeHours.length - 1 }]">
            <b-col
              :md="schedule_type === 'days_only' ? 6 : 4"
              class="text-capitalize operation-day">
              {{ operation.day }}
            </b-col>
            <b-col
              md="4"
              class="operation-hours text-left text-md-center text-capitalize store-hours"
              v-if="schedule_type === 'days_and_time'">
              {{ `${!operation.is_close ? `${transformTime(operation.start)} - ${transformTime(operation.end)}` : '-'}` }}
            </b-col>
            <b-col
              :md="schedule_type === 'days_only' ? 6 : 4"
              class="text-left text-md-right">
              <span class="text-uppercase rounded py-1 px-2 is-store-open store-open" v-if="!operation.is_close">Open</span>
              <span class="text-uppercase rounded py-1 px-2 is-store-open store-closed" v-if="operation.is_close">Closed</span>
            </b-col>
          </b-row>
        </div>
       </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col lg="2" md="4">
        <b-form-group label="Pre-Ordering Days" label-class="fulfillment-form-label">
        </b-form-group>
      </b-col>
       <b-col lg="10" md="8">
        <div class="bg-white rounded p-4 form-container">
          <b-form-group label="Set Standard Pre-Ordering Schedule" label-class="fulfillment-form-label-large"></b-form-group>
          <b-form-group label="Select Accepted Order">
            <b-row no-gutters>
              <b-col lg="2" md="3">
                <PreOrderingAcceptedOrderInputDropdown
                  :selectedValue="orders_accepted"
                  @setValue="handlSetAcceptedOrder"
                  error-key="orders_accepted"
                  :enabled="isSameAsDelivery"
                />
                <b-form-checkbox
                v-model="orders_accepted"
                value="No Limit"
                @change="handlSetAcceptedOrder"
                :disabled="isSameAsDelivery"
                >
                No Limit
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-form-group>
          <b-row
            no-gutters
            v-for="(operation, opIndex) in preOrderSchedule" :key="`operation_${opIndex}`"
            class="mt-3 operation-item p-2 border rounded d-flex align-items-center">
            <div class="px-2">
              <b-form-checkbox
                v-model="operation.enable"
                @change="handleSelectDay()"
                :disabled="operation.is_close || isSameAsDelivery" class="mt-2"
                :key="opIndex">
              </b-form-checkbox>
            </div>
            <div class="flex-grow-1">
              <b-row class="d-flex align-items-center justify-content-between">
                <b-col
                  :md="schedule_type === 'days' ? 6 : 4"
                  class="text-capitalize operation-day">
                  {{ operation.day }}
                </b-col>
                <b-col
                  md="4"
                  class="operation-hours text-capitalize store-hours"
                  v-if="schedule_type === 'days_and_time'">
                  <div class="d-flex align-items-center">
                    <TimeInputDropdownComponent
                      :enabled="operation.enable && !isSameAsDelivery && !operation.is_close"
                      :minimum="storeHours[opIndex].start"
                      :maximum="storeHours[opIndex].end"
                      origin="minimum"
                      :index="opIndex"
                      @setValue="handleSetTimeValue"
                      :selectedValue="operation.start"
                    />
                    <span class="px-2">-</span>
                    <TimeInputDropdownComponent
                      :enabled="operation.enable && !isSameAsDelivery && !operation.is_close"
                      :minimum="operation.start"
                      :maximum="storeHours[opIndex].end"
                      origin="maximum"
                      :index="opIndex"
                      @setValue="handleSetTimeValue"
                      :selectedValue="operation.end"
                    />
                  </div>
                </b-col>
                <b-col
                  :md="schedule_type === 'days' ? 6 : 4"
                  class="text-left text-md-right">
                  <span class="text-uppercase rounded py-1 px-2 is-store-open store-open" v-if="!operation.is_close">Open</span>
                  <span class="text-uppercase rounded py-1 px-2 is-store-open store-closed" v-if="operation.is_close">Closed</span>
                </b-col>
              </b-row>
            </div>
          </b-row>
        </div>
       </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions, mapState } from "vuex";
import PreOrderingAcceptedOrderInputDropdown from "./AcceptedOrderInputDropdown";
import TimeInputDropdownComponent from "./TimeInputDropdown";
import _ from "lodash";

export default {
  name: "FulfillmentPreOrdering",
  components: { PreOrderingAcceptedOrderInputDropdown, TimeInputDropdownComponent },
  data() {
    return {
      schedule_type: 'days_only',
      orders_accepted: null,
      preOrderSchedule: []
    }
  },
  computed: {
    ...mapGetters({
      pre_order_schedule: 'orderFulfillment/pre_order_schedule',
      errors: 'orderFulfillment/errors',
    }),
    ...mapState("auth", {
      user: state => state.user
    }),
    ...mapState("merchants", {
      moduleList: state => state.moduleList
    }),
    storeInfo: {
      get() {
        return this.pre_order_schedule ? this.pre_order_schedule.store_info : null;
      },
      set(info) {
        return info;
      }
    },
    routerLinkProperties: {
      get() {
        return this.$route.params ? this.$route.params : null
      },
      set(properties) {
        return properties;
      }
    },
    displayName: {
      get() {
        return `${this.storeInfo ? this.storeInfo.brand_name : ''} - ${this.storeInfo ? this.storeInfo.branch_name : ''}`;
      },
      set(name) {
        return name;
      }
    },
    storeHours: {
      get() {
        return this.pre_order_schedule
          ? Object.keys(this.pre_order_schedule.store_hours).map(day => {
            const store_hours = [];
            const store = this.pre_order_schedule.store_hours[day];
            store['day'] = day;
            store_hours.push(store);
            return store_hours.flat();
          }).flat()
          : []
      },
      set(store_hours) {
        return store_hours;
      }
    },
    isSameAsDelivery: {
      get() {
        return this.pre_order_schedule
          && this.pre_order_schedule.fulfillment_type === 'pickup'
          && this.pre_order_schedule.same_as_delivery
            ? this.pre_order_schedule.same_as_delivery
            : false;
      },
      set(status) {
        return status;
      }
    }
  },
  mounted() {
    this.$root.$on('handleFulfillmentSave', (origin) => {
      this.handleSavePreOrderingSchedule();
    });
    this.$root.$on('saveFulfillmentChangesCancelled', (origin) => {
      this.handleGetPreOrderingSchedule();
    });
  },
  beforeDestroy() {
    this.$root.$off('handleFulfillmentSave');
    this.$root.$off('saveFulfillmentChangesCancelled');
  },
  async created() {
    this.handleGetPreOrderingSchedule();
  },
  methods: {
    ...mapActions({
      getPreOrderingSchedule: 'orderFulfillment/getPreOrderingSchedule',
      savePreOrderingSchedule: 'orderFulfillment/savePreOrderingSchedule'
    }),
    transformTime(time) {
      return this.$moment().set("hour", time.split(':')[0]).set("minute", time.split(':')[1]).format('h:mm A');
    },
    handleSelectDay() {
      this.$root.$emit("changesDetected");
    },
    handlSetAcceptedOrder(value) {
      this.$root.$emit("changesDetected");
      this.orders_accepted = value;
      if (this.orders_accepted === false) {
                this.orders_accepted = Number(this.pre_order_schedule.orders_accepted) ? Number(this.pre_order_schedule.orders_accepted): "";
            }
    },
    handleSetTimeValue(data) {
      const time = moment(moment(data.value, "h:mm A")._d).format("HH:mm");
      this.preOrderSchedule[data.opIndex][`${data.origin === 'minimum' ? 'start' : 'end'}`] = time;
      const opening = this.preOrderSchedule[data.opIndex].start;
      const closing = this.preOrderSchedule[data.opIndex].end;
      const storeClosing = this.storeHours[data.opIndex].end;
      if (opening > closing && closing > storeClosing) this.preOrderSchedule[data.opIndex].end = moment(moment(opening, "HH:mm")._d).add(30, 'minutes').format("HH:mm");
      this.$forceUpdate();
    },
    handleGoBack() {
      const isShowSaveAlert = this.$router.app.$children[0].$children.find(child => child.$el.id === 'fulfillment-container').isShowSaveAlert;
      if (!isShowSaveAlert) this.$router.go(-1);
    },
    handleIdentifyFulfillmentType() {
      const fulfillment_types = {
        'FulfillmentDeliveryPreOrdering': 'delivery',
        'FulfillmentPickupPreOrdering': 'pickup'
      };
      const route_name = this.$route.name;
      return fulfillment_types[route_name];
    },
    async handleGetPreOrderingSchedule() {
      const route_params = this.$route.params;
      const params = {
        brand_uuid: route_params.brand_uuid,
        branch_uuid: route_params.branch_uuid,
        fulfillment_type: this.handleIdentifyFulfillmentType()
      };
      await this.getPreOrderingSchedule(params);
      this.setPreOrderScheduleValues();
    },
    setPreOrderScheduleValues() {
      this.orders_accepted = this.pre_order_schedule.orders_accepted === 0 ? 'No Limit' : this.pre_order_schedule.orders_accepted;
      this.schedule_type = this.pre_order_schedule.schedule_type ? this.pre_order_schedule.schedule_type : 'days_only';
      const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      this.preOrderSchedule = this.pre_order_schedule
        ? days.map(day => {
          const schedules = [];
          const store = this.pre_order_schedule.pre_order_schedules[day];
          store['day'] = day;
          store['is_close'] = this.pre_order_schedule.store_hours[day].is_close;
          schedules.push(store);
          return schedules;
        }).flat()
        : [];
    },
    transformPreOrderSchedule() {
      const objectifyPreOrderSchedule = {};
      this.preOrderSchedule.map(day => {
        objectifyPreOrderSchedule[`${day.day}`] = {
          start: day.start,
          end: day.end,
          enable: day.enable
        };
      });
      return objectifyPreOrderSchedule;
    },
    async handleSavePreOrderingSchedule() {
      const routeParams = this.$route.params;
      const payload = {
        branch_uuid: routeParams.branch_uuid,
        brand_uuid: routeParams.brand_uuid,
        orders_accepted: this.orders_accepted === 'No Limit' ? 0 : Number(this.orders_accepted),
        schedule_type: this.schedule_type,
        fulfillment_type: this.handleIdentifyFulfillmentType(),
        pre_order_schedules: this.transformPreOrderSchedule()
      };
      await this.savePreOrderingSchedule(payload);
      if (!this.errors) {
        this.$root.$emit('fulfillmentSavedSuccessful');
        this.handleGetPreOrderingSchedule();
      }
    },
    // Disable / Enable Edit Store Hours Button
    isStoreModule() {
      if (this.user) {
        if (this.user.role === 'admin' && this.isModuleAvailableInPlan('store')) return true;

        const moduleIcon = _.findIndex(this.user.cms_permissions, function(data) {
          return data.includes('store.organization');
        });

        return moduleIcon !== -1 && this.isModuleAvailableInPlan('store');
      }
      return false;
    },
    isModuleAvailableInPlan(module) {
      if (!this.moduleList) return false;
      
      return this.moduleList.some(m => m.code.includes(module));
    },
  },
}
</script>

<style lang="scss">
@import url('../../assets/scss/fulfillment/_base.scss');
</style>

<style lang="scss" scoped>
.btn.btn-ghost.go-back-btn {
  color: #5182FF;
  font-size: 14px;
  font-family: MainFontBold, sans-serif;
}
.btn.btn-outline-primary.go-to-edit-store {
  border-radius: 20px;
  &:hover {
    background: transparent;
    color: inherit;
  }
  &.outline-disabled {
    border-color: gray !important;
    color: gray;
    cursor: not-allowed;
    & > img {
      filter: grayscale(1);
    }
  }
}
h2 {
  color: #2F3941;
  font-size: 22px;
  font-family: MainFontBold, sans-serif;
}
#schedule-tabs .navbar-nav .nav-item .nav-link {
  color: #2F3941;
  font-size: 16px;
  font-family: MainFontBold, sans-serif;
  &.active {
    border-bottom: solid 3px #FF8A00;
  }
}
.store-edit-note {
  max-width: fit-content;
}
.operation-item {
  .operation-day,
  .operation-hours {
    color: #2F3941;
    font-size: 14px;
    font-family: MainFontBold, sans-serif;
  }
  .is-store-open {
    font-size: 14px;
    font-family: MainFontBold, sans-serif;
    &.store-open {
      color: #0BC254;
      background: rgba(35, 213, 106, 0.08);
    }
    &.store-closed {
      color: #FF2D2D;
      background: rgba(255, 45, 45, 0.08);
    }
  }
}
.disabled-edit-store-hours {
  cursor: not-allowed;
  pointer-events: none;
}
</style>
